module.exports = "/assets/data/0c6903659644f160f911c84dff6f7efa-G67.data.json";